import VueGoogleMaps from '@fawmi/vue-google-maps'
import '@assets/css/index.css'
import '@assets/css/style.css'

import { createApp } from 'vue'
import { createI18n } from 'vue-i18n'
import { createPinia } from 'pinia'
import VueApexCharts from 'vue3-apexcharts'
import { getItemLocalStorage } from '@utils/helper.utils.js'

import App from './App.vue'
import router from './router'
import resetStore from './store/reset.store'
import en from './lang/en'
import fr from '@/lang/fr.json'
import countries from '@/utils/countries'

// import * as Sentry from '@sentry/vue'

const pinia = createPinia()
pinia.use(resetStore)
const app = createApp(App)
// Sentry.init({
//   app,
//   dsn: 'https://0ba11a4f6a9d2ee29691d3b1e066f69f@sentry.volaneapps.com/4',
//   // Setting this option to true will send default PII data to Sentry.
//   // For example, automatic IP address collection on events
//   sendDefaultPii: true,
//   integrations: [Sentry.replayIntegration()],
//   // Session Replay
//   replaysSessionSampleRate: import.meta?.env?.NODE_ENV?.toLowerCase().includes(
//     'prod',
//   )
//     ? 0.1
//     : 1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// })

export const i18n = createI18n({
  // something vue-i18n options here ...
  legacy: false, // you must set `false`, to use Composition API
  locale:
    getItemLocalStorage('locale') ||
    countries[import.meta.env.VITE_INSTITUATION].default_locale_lang,
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
  },
})

app.use(pinia)
app.use(i18n)
app.use(router)
app.use(VueGoogleMaps, {
  load: {
    key: import.meta.env.VITE_GOOGLE_API_KEY,
    libraries: 'places',
  },
})

app.use(VueApexCharts)

app.mount('#app')
